import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { updatePropertyID } from '../../actions/FlowAction'
import { getUserToken } from '../../services/userService'
import { getPrefixPath } from '../../services/routeService'

const PrivateRoute = props => {
  React.useEffect(() => {
    if (props.match && props.match.params && props.match.params.id) {
      props.setPropertyId(props.match.params.id)
    }
  }, [])
  const { component: Component } = props
  const hasToken = !!getUserToken()

  return hasToken ? <Component {...props} /> : <Redirect to={getPrefixPath() + `/login${props.location.search}`} />
}

const mapDispatchToProps = dispatch => ({
  setPropertyId: id => dispatch(updatePropertyID(id)),
})

PrivateRoute.propTypes = {
  containerComponent: PropTypes.any,
  component: PropTypes.any,
}
export default connect(
  () => ({}),
  mapDispatchToProps,
)(PrivateRoute)



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js